import { Crown } from "lucide-react";

const Band = ({ colors, vertical }) => (
  <span className={`absolute inset-0 flex ${vertical ? "flex-row" : "flex-col"}`}>
    {colors.map((c, i) => <span key={i} className="flex-1" style={{ background: c }} />)}
  </span>
);

export const FLAGS = [
  { code: "CH", name: "Schweiz", el: null },
  { code: "IT", name: "Italia", el: <Band vertical colors={["#009246", "#fff", "#ce2b37"]} /> },
  { code: "DE", name: "Deutschland", el: <Band colors={["#000", "#dd0000", "#ffce00"]} /> },
  { code: "AT", name: "Österreich", el: <Band colors={["#ed2939", "#fff", "#ed2939"]} /> },
  { code: "LI", name: "Liechtenstein", el: (<><Band colors={["#002b7f", "#ce1126"]} /><Crown className="absolute top-[3px] left-[5px] w-3 h-3 text-[#ffd83d]" strokeWidth={2.5} /></>) },
];

export const Flag = ({ f, className = "" }) => (
  <span className={`flag ${f.code === "CH" ? "flag-ch" : ""} ${className}`} title={f.name} aria-label={f.name} role="img">{f.el}</span>
);

export const FlagRow = ({ labels = true, className = "", testid = "flag-row" }) => (
  <ul className={`flex flex-wrap items-end gap-3 ${className}`} data-testid={testid}>
    {FLAGS.map((f) => (
      <li key={f.code} className="flex flex-col items-center gap-1.5" data-testid={`flag-${f.code.toLowerCase()}`}>
        {labels && <span className="font-mono text-[11px] tracking-[0.2em] text-slate-200">{f.code}</span>}
        <Flag f={f} />
      </li>
    ))}
  </ul>
);
